import { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputText } from "primereact/inputtext";
import { v4 as uuidv4 } from "uuid";

import "./keyValues.styles.scss";
import { useDispatch } from "react-redux";
import { setToast } from "../../app/appSlice";
import UploadEnvironnementVar from "../UploadEnvironnementVar";
export interface IKeyValue {
  name: string;
  value: string;
}

export interface IKeyValueWithID extends IKeyValue {
  id: string;
}

export const KeyValuesInput = ({
  value,
  onChange,
  defaultValue,
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {
  const verifyType = (value: any) => {
    let typeIsVerify = true;
    if (Array.isArray(value)) {
      for (let i of value) {
        if (
          Object.keys(i).length !== 2 ||
          typeof i?.name !== "string" ||
          typeof i?.value !== "string"
        ) {
          typeIsVerify = false;
          break;
        }
      }
    } else {
      typeIsVerify = false;
    }
    return typeIsVerify;
  };

  const dispatch = useDispatch();

  const [incorrectDefaultValue, setIncorrectDefaultValue] =
    useState<boolean>(false);

  const [keyValues, setKeyValues] = useState<IKeyValueWithID[]>(() => {
    let initValue: IKeyValue[] = [];
    if (value) {
      const typeVerified = verifyType(value);
      if (typeVerified) initValue = value;
    } else if (defaultValue) {
      const typeVerified = verifyType(defaultValue);
      if (typeVerified) initValue = defaultValue;
      else setIncorrectDefaultValue(true);
    }
    const initValueWithID: IKeyValueWithID[] = initValue.map((val) => ({
      id: uuidv4(),
      name: val.name,
      value: val.value,
    }));
    return initValueWithID;
  });

  const addItem = () => {
    if (keyValues.find((element) => element.name === "")) {
      dispatch(
        setToast({
          content: "une variable vide existe déjà",
          life: 3000,
          severity: "error",
          title: "Erreur",
        })
      );
    } else {
      const tempItems = Array.from(keyValues);
      tempItems.push({ name: "", value: "", id: uuidv4() });
      setKeyValues(tempItems);
      setIncorrectDefaultValue(false);
      onChange(tempItems.map((val) => ({ name: val.name, value: val.value })));
    }
  };
  const deleteItem = (index: number) => {
    const tempItems = Array.from(keyValues);
    tempItems.splice(index, 1);
    setKeyValues(tempItems);
    onChange(tempItems.map((val) => ({ name: val.name, value: val.value })));
  };

  const udpateItem = (index: number, value: IKeyValueWithID) => {
    const tmpItems = Array.from(keyValues);
    tmpItems[index] = value;

    onChange(tmpItems.map((val) => ({ name: val.name, value: val.value })));
    setKeyValues(tmpItems);
  };

  return (
    <div className="avro mt-5 mb-2">

      {incorrectDefaultValue && (
        <div className="error-text">
          La valeur par défaut est incorrecte, veuillez la corriger ou saisir
          une valeur afin de l'écraser
        </div>
      )}
      <div className="titles">
        <div className="row">VARIABLE</div>
        <div className="row ">VALEUR</div>
      </div>
      {keyValues &&
        keyValues.map((item, index) => (
          <div className="rowAvro" key={item.id}>
            <div className="fields">
              <div className="input">
                <InputText
                  value={item.name}
                  className="w-full h-full"
                  onChange={(e) => {
                    udpateItem(index, {
                      name: e.target.value,
                      id: item.id,
                      value: item.value,
                    });
                  }}
                />
              </div>
              <div className="input">
                <InputText
                  value={item.value}
                  className="w-full h-full"
                  onChange={(e) => {
                    udpateItem(index, {
                      name: item.name,
                      id: item.id,
                      value: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="cross">
              <FontAwesomeIcon
                className="icon"
                icon={"xmark"}
                onClick={() => {
                  deleteItem(index);
                }}
              />
            </div>
          </div>
        ))}
      <div className="flex justify-content-center">
        <Button
          className=" mt-3 p-button-text"
          type="button"
          label="AJOUTER UNE VARIABLE"
          onClick={() => addItem()}
          icon="pi pi-plus"
        />
      </div>
      <div>
            <UploadEnvironnementVar onChange={(fileEnv) => {
                if(!value)onChange(fileEnv)
                else onChange([...fileEnv,...value]);
                setKeyValues((prev) => {
                    return [
                        ...prev,
                        ...fileEnv.map((val) => ({
                            id: uuidv4(),
                            name: val.name,
                            value: val.value,
                          }))
                    ]
                })
            }
            }
            existingEnvVar={keyValues}
            ></UploadEnvironnementVar>
        </div>
    </div>
  );
};
